import { render } from "./CheckoutThanks.vue?vue&type=template&id=a6a8d586"
import script from "./CheckoutThanks.vue?vue&type=script&lang=js"
export * from "./CheckoutThanks.vue?vue&type=script&lang=js"

import exportComponent from "/Users/andrei/Desktop/EO LARAVEL/club-shops-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__